import { Component, Vue, namespace } from 'nuxt-property-decorator';
import { IPage } from '../entities/content-entity';
import { namespace as cmsStore, actionType, IGetPageParams } from '../store/modules/cms-store';

const CmsStore = namespace(cmsStore);

@Component
export default class CmsMixin extends Vue {
	@CmsStore.Action(actionType.GET_MENU) getMenu!: () => void;
	@CmsStore.Action(actionType.GET_PAGE) getPage!: (params: IGetPageParams) => Promise<IPage | undefined>;
	@CmsStore.Action(actionType.GET_PAGE_BY_ID) getPageById!: (pageId: number) => Promise<IPage | undefined>;
	@CmsStore.Action(actionType.RESET_STATE) readonly resetCmsState!: () => void;
	@CmsStore.Getter menu!: any[];
	@CmsStore.Getter flatMenu!: any[];
	@CmsStore.Getter page!: IPage;
	@CmsStore.Getter('allMenus') allCmsMenus!: any[];
	@CmsStore.Getter('getMenu') getCmsMenu!: (name: string) => any;

	destroyed(): void {
		this.resetCmsState();
	}
}
